import pdfMake from 'pdfmake/build/pdfmake';
import type { TDocumentDefinitions } from 'pdfmake/interfaces';

import fonts from './fonts';
pdfMake.addVirtualFileSystem(fonts);

// Downloads via a blob + anchor click rather than opening a new window:
// download() runs after awaited data fetches, outside the click gesture, so
// window.open here is rejected by popup blockers (CUS-206).
export const download = (doc: TDocumentDefinitions) => {
  // Third Party passes a bare user-entered title, so it can already end in .pdf.
  const title = doc.info?.title?.trim();
  const fileName = title ? `${title.replace(/\.pdf$/i, '')}.pdf` : 'export.pdf';
  pdfMake.createPdf(doc).download(fileName);
};
